import React, { useEffect } from "react";
import ProfileAndSecurity from "./ProfileAndSecurity";
import { fetchAdminProfileAsync } from "../../../redux/features/adminSlice";
import { useAppDispatch } from "../../../redux/app/hooks";

const Settings = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAdminProfileAsync());
  }, [dispatch]);

  return (
    <div className=" flex flex-col gap-6 p-6 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold ">Profile Setting</h1>
      </div>
      <ProfileAndSecurity />
    </div>
  );
};

export default Settings;
